"use client";

import { createContext, useContext, type ReactNode } from "react";

import type { UserSummary } from "@/lib/auth/user-summary";

const MarketingUserContext = createContext<UserSummary | null>(null);

export function MarketingUserProvider({
  children,
  user,
}: {
  children: ReactNode;
  user: UserSummary | null;
}) {
  return (
    <MarketingUserContext.Provider value={user}>
      {children}
    </MarketingUserContext.Provider>
  );
}

export function useMarketingUser() {
  return useContext(MarketingUserContext);
}
